import {Service} from "@/apiServices/Service";

export class FormaPagoService extends Service {
    constructor() {
        super('forma/');
    }

    obtenerFormasPagoPTI(idPti) {
        this.onStart();
        return this.http.post(this.getUrl(['detalle', 'pago']), idPti)
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerMinimoFinanciera(idFinanciera) {
        this.onStart();
        return this.http.post(this.getUrl(['obtener', 'minimo']), idFinanciera)
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
}
